import * as React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

// Helper to format date as dd-MMM-yyyy
function formatDateToCustom(date) {
  if (!date) return '';
  const d = new Date(date);
  const day = d.getDate().toString().padStart(2, '0');
  const month = d.toLocaleString('en-US', { month: 'short' });
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
}

export default function CustomDatePicker({ label, value, onChange, ...props }) {
  // Ensure value is a Date object or null
  const dateValue = value instanceof Date ? value : (value ? new Date(value) : null);
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label={label}
        value={dateValue}
        onChange={onChange}
        format="dd-MMM-yyyy"
        // For MUI v6+, use slotProps to control input rendering
        slotProps={{
          textField: {
            size: 'small',
            InputLabelProps: { shrink: true },
            inputProps: {
              'aria-label': `${label} input - you can type directly or use calendar picker`
            }
          }
        }}
        {...props}
      />
    </LocalizationProvider>
  );
}
